module.exports = __webpack_public_path__ + "img/weddings_18_V.5336a27d.webp";